(function () {
  var STORAGE_KEY = 'cookie_banner_dismissed';
  var SEVEN_DAYS = 7 * 24 * 60 * 60 * 1000;

  var banner = document.getElementById('cookie-banner');
  if (!banner) return;

  function shouldShow() {
    var stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return true;
    var ts = parseInt(stored, 10);
    if (isNaN(ts)) return true;
    return Date.now() - ts >= SEVEN_DAYS;
  }

  function dismiss() {
    banner.classList.remove('is-visible');
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
  }

  if (!shouldShow()) return;

  banner.classList.add('is-visible');

  var btn = document.getElementById('cookie-banner-btn');
  if (btn) {
    btn.addEventListener('click', dismiss);
  }

  var autoDismiss = banner.dataset.autoDismiss === 'true';
  var seconds = parseInt(banner.dataset.autoDismissSeconds, 10);
  if (autoDismiss && seconds > 0) {
    setTimeout(dismiss, seconds * 1000);
  }
})();
